import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  mongoSQLSetting: [],
  removeFromMongoSetting: [],
  totalCount: 0,
  totalPurchaseCount: 0,
};

const slice = createSlice({
  name: "HistoricalData",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getMongoSQLSetting.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getMongoSQLSetting.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      mongoSQLSetting: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getMongoSQLSetting.rejected, (state, action) => ({
      ...state,
      loading: false,
      mongoSQLSetting: [],
      totalCount: 0,
    }));
    builder.addCase(Act.getRemoveFromMongo.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getRemoveFromMongo.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      removeFromMongoSetting: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getRemoveFromMongo.rejected, (state, action) => ({
      ...state,
      loading: false,
      removeFromMongoSetting: [],
      totalCount: 0,
    }));

    builder.addCase(Act.deleteMongoSQLSetting.pending, (state) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.deleteMongoSQLSetting.fulfilled, (state) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.deleteMongoSQLSetting.rejected, (state) => ({
      ...state,
      loading: false,
    }));
  },
});

export default slice;
